import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ScreenInitialComponent } from '@kp/screen-initial/screen-initial.component';

const routes: Routes = [{ path: '', component: ScreenInitialComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ScreenInitialRoutingModule {
  static components = [ScreenInitialComponent];
}
